<div class="main-content" id="main-content">
   <section id="breadcrumbs">
      <div class="container-lg">
         <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
               <div class="br-breadcrumb">
                  <ul class="crumb-list">
                     <li class="crumb home">
                        <a class="br-button circle" [routerLink]="['/']">
                           <span class="sr-only">Página inicial</span>
                           <i class="fas fa-home"></i>
                        </a>
                     </li>
                     <li class="crumb" data-active="active">
                        <i class="icon fas fa-chevron-right"></i>
                        <span>Legislação</span>
                     </li>
                  </ul>
               </div>
            </div>
         </div>
      </div>
   </section>

   <section id="page">
      <div class="container-lg">
         <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
               <h2>Legislação</h2>
               <div *ngFor="let legislacao of legislacoes">
                  <p class="padding" *ngIf="legislacao.mensagem">
                     {{ legislacao.mensagem }}
                  </p>
                  <p class="padding">
                     <a
                        href="{{ legislacao.link }}"
                        target="_blank"
                        rel="noreferrer"
                        class="link custom-link"
                        >{{ legislacao.nome }}</a
                     >
                     - {{ legislacao.descricao }}
                  </p>
               </div>
            </div>
         </div>
      </div>
   </section>
</div>
<!-- /Conteúdo -->
